module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABSUlEQVQ4T6WTv0oDQRDGvwlBsiBWqRQfQLYwZPcQy2usxMLCQkvBysZSLcRGSxsrKxsbS7GysZRwO0cKFx9AzAMYYYNcWFnxQmIuEbxtBnZnft/OP0LJQyXjMQaw1s70er09ADveexkEiMgCuKnValdSys9h0RFAu91eyLLsnohevfcXQogkODvnIiI68N4vVqvV9Uaj8ZZDBoCg7JxrAbjVWp8HB2ZeClYp9RKsMeYQwJYQYiX/yQDAzPsA1pRSGzmdmU9+AKdDd3cAHpRSl9/pDT08ee+PtNaP0wDGmJiIzpRSqyMAY8y7EGJeSvkxDWCtnXXOdbTWc38CkiQ5JqLlbre7HcdxFgImAph5LAVjTB3ANYB6pVLZbDabnYkpFBUxTyVN091+v9+KouiZmYuLWNTG31M6tY3BudQg5WqlRvk/i1V6G78AtHDDEVvkK3sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clock.png
// module id = H/63
// module chunks = 1 5